import { AxiosPromise } from 'axios';
import { ApiResponseEntity, CompanyDTO, EmailParamsDTO, FormParamsDTO, ParamRequestDTO, CompanyRequestDTO, AppParamsDTO } from 'types';

import axios from 'utils/axios';

const API_PATH = '/secured/company';

export default class CompanyApi {
    static getCompanyInfo(): AxiosPromise<ApiResponseEntity<CompanyDTO>> {
        return axios.get(`${API_PATH}/info`);
    }

    static updateCompanyInfo(data: CompanyRequestDTO): AxiosPromise<ApiResponseEntity<CompanyDTO>> {
        return axios.post(`${API_PATH}/info`, data);
    }

    static getCompanyFormSetting(): AxiosPromise<ApiResponseEntity<FormParamsDTO>> {
        return axios.get(`${API_PATH}/setting/FORM`);
    }

    static getCompanyAppSetting(): AxiosPromise<ApiResponseEntity<AppParamsDTO>> {
        return axios.get(`${API_PATH}/setting/APP`);
    }

    static getCompanyEmailSetting(): AxiosPromise<ApiResponseEntity<EmailParamsDTO>> {
        return axios.get(`${API_PATH}/setting/EMAIL`);
    }

    static updateCompanyEmailSetting(data: EmailParamsDTO): AxiosPromise<ApiResponseEntity<EmailParamsDTO>> {
        return axios.post(`${API_PATH}/setting/EMAIL`, data);
    }

    static updateCompanyFormSetting(data: ParamRequestDTO): AxiosPromise<ApiResponseEntity<FormParamsDTO>> {
        return axios.post(`${API_PATH}/setting/FORM`, data);
    }

    static updateCompanyAppSetting(data: ParamRequestDTO): AxiosPromise<ApiResponseEntity<AppParamsDTO>> {
        return axios.post(`${API_PATH}/setting/APP`, data);
    }

    static testEmail(data: EmailParamsDTO): AxiosPromise<ApiResponseEntity<void>> {
        return axios.post(`${API_PATH}/setting/email/connection-test`, data);
    }
}
